/*
 * StoryCard — reusable editorial story card with image zoom + gold hover rule.
 */
import { Link } from "wouter";
import type { Article } from "@/content/types";
import ResponsiveImage from "@/components/ResponsiveImage";

export default function StoryCard({
  article,
  large = false,
  index = 0,
}: {
  article: Article;
  large?: boolean;
  index?: number;
}) {
  return (
    <Link
      href={`/${article.section}/${article.slug}`}
      className="story-card group block reveal"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="editorial-img overflow-hidden bg-secondary">
        <ResponsiveImage
          src={article.image}
          alt={article.imageAlt}
          sizes={large ? "(min-width: 1024px) 58vw, 100vw" : "(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"}
          className={`w-full object-cover ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}
        />
      </div>
      <div className="pt-4">
        <div className="flex items-center gap-3">
          <span className="kicker">{article.tags[0]}</span>
          <span className="h-px flex-1 bg-border" />
        </div>
        <h3
          className={`font-display mt-2 font-bold leading-snug group-hover:text-[var(--gold-2)] transition-colors duration-200 ${
            large ? "text-2xl md:text-3xl" : "text-xl"
          }`}
        >
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed line-clamp-2">
          {article.dek}
        </p>
        <p className="mt-3 text-xs uppercase tracking-[0.16em] text-muted-foreground/80">
          {article.author} · {article.readTime}
        </p>
      </div>
    </Link>
  );
}
